import type { RawKey } from './zh-CN';

/** Filipino. Keep every key explicit so missing translations fail typechecking. */
export const fil: Record<RawKey, string> = {
  'tab.lobby': 'Lobby',
  'tab.activity': 'Mga promo',
  'tab.agent': 'Ahente',
  'tab.deposit': 'Deposito',
  'tab.profile': 'Ako',

  'action.loginOrRegister': 'Mag-log in',
  'action.login': 'Mag-log in',
  'action.register': 'Magrehistro',
  'action.close': 'Isara',
  'action.settings': 'Mga setting',
  'action.myAccount': 'Aking account',
  'action.working': 'Maghintay sandali…',
  'action.view': 'Tingnan',
  'action.retry': 'Subukan muli',

  'lobby.hot': 'Patok',
  'lobby.more': 'Higit pa',
  'lobby.less': 'Mas kaunti',
  'lobby.providers': 'Mga provider ng laro',
  'lobby.allProviders': 'Lahat',
  'lobby.otherProvider': 'Iba pa',
  'lobby.title': 'Lobby',
  'lobby.count_one': '{n} laro',
  'lobby.count_other': '{n} laro',
  'lobby.none': 'Walang available na laro sa ngayon',
  'lobby.maintenance': 'Kasalukuyang minementina',
  'lobby.unavailable': 'Pansamantalang hindi available',
  'lobby.laterNote': 'Paparating ang mga kategorya, kamakailang nilaro at mga filter ng provider.',
  'lobby.search': 'Maghanap ng laro',
  'lobby.noMatch': 'Walang larong tumutugma sa “{q}”',
  'lobby.liveTables': 'Mga live na mesa',
  'lobby.tableClosed': 'Sarado ang mesa',
  'lobby.liveUnavailable': 'Hindi available ang live na data',
  'lobby.dealer': 'Dealer',
  'lobby.betLimits': 'Mga limitasyon ng taya',
  'lobby.players': 'Mga manlalaro',
  'lobby.seats': 'Mga bakanteng upuan',
  'lobby.recentResults': 'Mga huling resulta',
  'lobby.shoe': 'Banker / Player / Tabla',
  'lobby.newTable': 'Bagong mesa',

  'game.tag_one': '{provider} · {grid} · {n} linya',
  'game.tag_other': '{provider} · {grid} · {n} linya',
  'game.tagGrid': '{provider} · {grid}',
  'game.tagLines_one': '{provider} · {n} linya',
  'game.tagLines_other': '{provider} · {n} linya',

  'placeholder.activity': 'Mga promo, misyon, araw-araw na check-in at ranggo — hindi pa available',
  'placeholder.agent': 'Mga referral link, kasapi ng team at komisyon — hindi pa available',
  'placeholder.deposit': 'Kailangan muna ang talaan ng transaksyon para sa deposito at pag-withdraw',
  'placeholder.profile': 'Profile, kasaysayan ng taya at seguridad — nasa Mga setting muna ang mga paunang feature',

  'auth.phone': 'Numero ng telepono',
  'auth.phoneHint': 'Piliin ang bansa at ilagay ang numero. Halimbawa: {example}',
  'auth.countryLoading': 'Nilo-load ang mga country code…',
  'auth.countryLoadFailed': 'Hindi ma-load ang mga bansa. Subukan muli.',
  'auth.registrationClosed': 'Sarado muna ang pagpaparehistro. Maaari pa ring mag-log in ang mga may account.',
  'err.REGISTRATION_COUNTRY_DISABLED': 'Hindi bukas ang pagpaparehistro sa bansang ito. Pumili ng bukas na bansa.',
  'auth.countryCode': 'Country code',
  'auth.country.PH': 'Pilipinas',
  'auth.country.BR': 'Brazil',
  'auth.password': 'Password',
  'auth.passwordHint': 'Hindi bababa sa 8 character',
  'auth.toRegister': 'Wala ka pang account? Magrehistro',
  'auth.toLogin': 'May account ka na? Mag-log in',
  'auth.noSmsYet': 'Hindi pa available ang SMS verification — wala kang matatanggap na code.',

  'err.BAD_CREDENTIALS': 'Mali ang numero ng telepono o password',
  'err.IDENTIFIER_TAKEN': 'Nakarehistro na ang numerong ito',
  'err.WEAK_PASSWORD': 'Dapat may hindi bababa sa 8 character ang password',
  'err.ACCOUNT_LOCKED': 'Masyadong maraming pagsubok. Subukan muli mamaya',
  'err.ACCOUNT_DISABLED': 'Naka-freeze ang account na ito',
  'err.NO_SESSION': 'Nag-expire ang iyong session. Mag-log in muli',
  'err.BAD_PHONE': 'Hindi valid ang numero — tingnan ang napiling bansa at numero',
  'history.status.open': 'Kasalukuyang nilalaro',
  'history.status.aborted': 'Naghihintay ng pag-aayos ng resulta',
  'history.status.settled': 'Naayos na',
  'history.status.canceled': 'Kinansela',
  'history.title': 'Kasaysayan ng taya',
  'history.empty': 'Wala pang naitalang round',
  'history.free': 'Libreng spin',
  'history.reward': 'Gantimpala',
  'history.adjustment': 'Pagsasaayos',
  'history.more': 'Magpakita pa',

  'err.GAME_UNAVAILABLE': 'Hindi available ang larong ito sa ngayon. Subukan muli mamaya',
  'err.NETWORK': 'Hindi makakonekta sa server',
  'err.UNKNOWN': 'May naganap na error. Subukan muli mamaya',

  'profile.balance': 'Balanse',
  'profile.vip': 'Antas ng VIP',
  'profile.wager': 'Kinakailangang itaya',
  'profile.wagerNone': 'Walang kinakailangang itaya sa ngayon',
  'profile.wagerDone': 'Natugunan na',
  'profile.rounds': 'Mga round na nilaro',
  'profile.noNickname': 'Wala pang palayaw',
  'profile.editNickname': 'Palitan ang palayaw',
  'profile.nickname': 'Palayaw',
  'profile.nicknameHint': '1–24 character',
  'profile.nicknameNotUnique': 'Maaaring magkapareho ang mga palayaw — ang ID ang laging pagkakakilanlan ng iyong account.',
  'profile.renamesLeft_one': '{n} pagpapalit ng pangalan ang natitira',
  'profile.renamesLeft_other': '{n} pagpapalit ng pangalan ang natitira',
  'profile.renamesNone': 'Wala nang natitirang pagpapalit ng pangalan',
  'profile.idLabel': 'ID {v}',
  'profile.copyId': 'Kopyahin ang ID',
  'profile.idCopied': 'Nakopya na',
  'profile.copyFailed': 'Hindi makopya — pindutin nang matagal ang ID para kopyahin',
  'err.NICKNAME_RENAME_LIMIT': 'Nagamit mo na ang lahat ng pagpapalit ng pangalan',
  'err.BAD_NICKNAME': 'Hindi pinapayagan ang palayaw na iyon',
  'err.NICKNAME_CHARS': 'May hindi nakikitang character ang palayaw mo, marahil mula sa pagkopya. Paki-type ito mismo.',
  'action.save': 'I-save',
  'profile.changeAvatar': 'Palitan ang avatar',
  'profile.uploadOwn': 'Mag-upload ng sarili mong larawan',
  'profile.uploadHint': 'JPG / PNG / WebP, hanggang 512 KB',
  'profile.yourUpload': 'Iyong na-upload',
  'profile.deposited': '{v} ang naideposito',
  'profile.maxLevel': 'Naabot na ang pinakamataas na antas',
  'profile.toNextLevel': 'Magdeposito pa ng {v} para maabot ang VIP {n}',
  'profile.perkFreeSpins': 'Araw-araw na libreng spin',
  'profile.perkDiscount': 'Bonus sa deposito',
  'profile.freeSpinsLeft': 'Natitirang libreng spin',
  'profile.claimDaily': 'Kunin ngayon',
  'profile.claimed': 'Nakuha na ngayong araw',
  'profile.noRewardYet': 'Wala pang available na gantimpala',
  'profile.rewardFromLevel': 'Nagsisimula sa VIP {n} ang araw-araw na libreng spin',
  'vip.title': 'Mga antas ng VIP',
  'vip.level': 'Antas',
  'vip.threshold': 'Naideposito',
  'vip.withdrawLimit': 'Araw-araw na pag-withdraw',
  'vip.you': 'ikaw',
  'vip.basis': 'Nakabatay ang antas ng VIP mo sa kabuuang kwalipikadong deposito.',
  'vip.noteClaim': 'Kunin ang araw-araw na libreng spin sa iyong profile, isang beses bawat araw. Kapag nakuha na, sa iyo na ang mga ito.',
  'vip.noteDiscount': 'Kasama sa iyong antas ang bonus sa deposito at araw-araw na limitasyon sa pag-withdraw — hindi na kailangang kunin.',
  'vip.noteMinWithdraw': 'Pinakamababang pag-withdraw sa bawat kahilingan: {v}.',
  'vip.noteMonotonic': 'Tumataas lang ang kabuuang deposito, kaya hindi bumababa ang iyong antas.',
  'vip.open': 'Tingnan ang mga antas ng VIP',
  'err.NOTHING_TO_CLAIM': 'Wala pang araw-araw na gantimpala ang iyong antas',
  'err.ALREADY_CLAIMED': 'Nakuha mo na ito ngayong araw',
  'err.INSUFFICIENT_FUNDS': 'Hindi sapat ang balanse',
  'err.BAD_REQUEST': 'May hindi wastong impormasyon',

  'settings.title': 'Mga setting',
  'settings.skin': 'Tema',
  'settings.mode': 'Hitsura',
  'settings.language': 'Wika',
  'settings.account': 'Account',
  'settings.notLoggedIn': 'Hindi naka-log in.',
  'settings.playerId': 'ID ng manlalaro',
  'settings.devices': 'Mga device na naka-log in',
  'settings.loading': 'Naglo-load…',
  'settings.unknownDevice': 'Hindi kilalang device',
  'settings.current': 'Ang device na ito',
  'settings.revokeOthers': 'I-log out ang ibang device',
  'settings.logout': 'Mag-log out',

  'skin.laroluna': 'LaroLuna · Liwanag ng buwan',
  'luna.title': 'Tuklasin ang bagong paborito.',
  'luna.note': 'Liwanag ng buwan. Mundo ng laro.',
  'skin.midnight': 'Hatinggabi',
  'skin.sunset': 'Takipsilim',
  'mode.system': 'System',
  'mode.dark': 'Madilim',
  'mode.light': 'Maliwanag',

  'time.justNow': 'Aktibo ngayon lang',
  'time.minutesAgo_one': '{n} minuto ang nakalipas',
  'time.minutesAgo_other': '{n} minuto ang nakalipas',
  'time.hoursAgo_one': '{n} oras ang nakalipas',
  'time.hoursAgo_other': '{n} oras ang nakalipas',
  'time.daysAgo_one': '{n} araw ang nakalipas',
  'time.daysAgo_other': '{n} araw ang nakalipas',

  'shop.title': 'Magdagdag ng balanse',
  'shop.buy': 'Bumili',
  'shop.bought': 'Naidagdag na',
  'shop.getCoins': 'Makakatanggap ka ng {v}',
  'shop.bonus': '+{v} na bonus',
  'shop.origPrice': 'dating {v}',
  'shop.soldOut': 'Naabot na ang limitasyon ngayong araw',
  'shop.leftToday_one': '{n} pagbili ang natitira ngayong araw',
  'shop.leftToday_other': '{n} pagbili ang natitira ngayong araw',
  'shop.limitToday_one': 'Hanggang {n} bawat araw',
  'shop.limitToday_other': 'Hanggang {n} bawat araw',
  'shop.empty': 'Walang available sa ngayon',
  'shop.devPay': 'Bersyon para sa development: agad na idinadagdag ang binili; walang tunay na bayad.',
  'shop.tag.hot': 'Sikat',
  'shop.tag.best': 'Pinakasulit',
  'shop.tag.daily': 'Araw-araw',
  'shop.tag.first': 'Unang pagbili',
  'shop.history': 'Kasaysayan ng pagbili',
  'shop.noHistory': 'Wala pang binili',
  'shop.st.created': 'Naghihintay ng bayad',
  'shop.st.paid': 'Idinadagdag sa balanse',
  'shop.st.credited': 'Naidagdag na',
  'shop.st.cancelled': 'Kinansela',
  'shop.st.expired': 'Nag-expire',

  'err.PRODUCT_UNAVAILABLE': 'Hindi available ang item na iyon sa ngayon',
  'err.PURCHASE_LIMIT': 'Naabot mo na ang limitasyon para sa item na ito ngayong araw',
  'err.CREDIT_FAILED': 'Natanggap ang bayad pero hindi dumating ang mga coin — makipag-ugnayan sa suporta',

  'withdraw.title': 'Mag-withdraw',
  'withdraw.action': 'Mag-withdraw',
  'withdraw.available': 'Available na balanse',
  'withdraw.payoutTo': 'Mga detalye ng tatanggap',
  'withdraw.noIdentity': 'Wala pang detalye ng tatanggap',
  'withdraw.bindFirst': 'Idagdag ang CPF ng tatanggap bago mag-withdraw',
  'withdraw.cpf': 'CPF',
  'withdraw.cpfHint': '11 digit, hal. {example}',
  'withdraw.holderName': 'Pangalan ng tatanggap',
  'withdraw.holderNameHint': 'Dapat tumugma sa pangalan sa CPF — sinusuri ito ng bangko',
  'withdraw.bind': 'I-save ang detalye ng tatanggap',
  'withdraw.bound': 'Na-save na',
  'withdraw.cannotUnbind': 'Hindi mo ito mababago nang sarili. Makipag-ugnayan sa suporta para i-update.',
  'withdraw.oncePerAccount': 'Isang CPF bawat account, at isang account lang ang maaaring gumamit ng bawat CPF.',
  'withdraw.wagerBlocked': 'Hindi pa natutugunan ang kinakailangang taya — {v} pa ang kulang',
  'withdraw.notOpenYet': 'Malapit nang magbukas ang pag-withdraw. Maaari mo nang idagdag ang detalye ng tatanggap.',

  'err.BAD_CPF': 'Hindi wasto ang CPF na iyon — pakisuri',
  'err.IDENTITY_TAKEN': 'Ginagamit na ang CPF na iyon',
  'err.IDENTITY_ALREADY_BOUND': 'May detalye na ng tatanggap ang account na ito',

  'withdraw.amount': 'Halaga',
  'withdraw.amountHint': '{min} – {max}',
  'withdraw.submit': 'Isumite ang kahilingan',
  'withdraw.submitted': 'Naisumite na ang kahilingan — naghihintay ng pagsusuri',
  'withdraw.all': 'Lahat',
  'withdraw.dailyLimit': 'Limitasyon ngayong araw',
  'withdraw.dailyLeft': '{v} ang natitira',
  'withdraw.vipTip': 'Maaaring mag-withdraw ng {v} bawat araw ang VIP {n} — magdeposito para tumaas ang limitasyon',
  'withdraw.history': 'Kasaysayan',
  'withdraw.noHistory': 'Wala pang pag-withdraw',
  'withdraw.st.pending': 'Sinusuri',
  'withdraw.st.approved': 'Naaprubahan',
  'withdraw.st.rejected': 'Tinanggihan',
  'withdraw.refunded': 'Naibalik ang halaga sa iyong balanse',

  'mail.title': 'Mga mensahe',
  'mail.entry': 'Mga mensahe',
  'mail.empty': 'Wala pang mensahe',
  'mail.unknown.title': 'Bagong mensahe',
  'mail.unknown.body': 'May bago kang mensahe.',
  'mail.withdrawPaid.title': 'Naipadala na ang withdrawal',
  'mail.withdrawPaid.body': 'Naipadala na ang iyong withdrawal na {amount} — natanggap mo ang {net} (bayarin: {fee}).',
  'mail.withdrawFailed.title': 'Hindi naipadala ang withdrawal',
  'mail.withdrawFailed.body': 'Hindi naipadala ang iyong withdrawal na {amount}. Naibalik na ang buong halaga sa iyong balanse.',
  'mail.withdrawRejected.title': 'Tinanggihan ang withdrawal',
  'mail.withdrawRejected.body': 'Hindi naaprubahan ang iyong withdrawal na {amount}. Naibalik na ang buong halaga sa iyong balanse.',
  'mail.attachment': 'Kalakip',
  'mail.coins': '{v} coin',
  'mail.wager': 'Kinakailangang itaya: {v}',
  'mail.wagerNote': 'Pagkatapos kunin, kailangan mong itaya ang halagang ito bago mag-withdraw',
  'mail.claim': 'Kunin',
  'mail.claimed': 'Nakuha na',
  'mail.claimedOk': 'Nakuha ang {v}',
  'mail.claimedOkWager': 'Nakuha ang {v} — kinakailangang taya +{w}',
  'err.NO_SUCH_MAIL': 'Wala ang mensaheng iyon',
  'action.more': 'Magpakita pa',

  'withdraw.fee': 'Bayarin',
  'withdraw.feeFree': 'Walang bayarin',
  'withdraw.net': 'Matatanggap mo',
  'withdraw.feeFreeAt': 'Walang bayarin mula VIP {n}',
  'withdraw.itemFee': 'Bayarin: {f} · natanggap: {v}',
  'withdraw.submittedFee': 'Naisumite na — matatanggap mo ang {v} (bayarin: {f})',
  'withdraw.noQuotaLeft': 'Naubos na ang limitasyon ngayong araw',

  'err.NO_PAYOUT_IDENTITY': 'Idagdag muna ang detalye ng tatanggap',
  'err.WAGER_NOT_MET': 'Hindi pa natutugunan ang kinakailangang taya',
  'err.WITHDRAW_TOO_SMALL': 'Mas mababa sa minimum na pag-withdraw',
  'err.WITHDRAW_OVER_LIMIT': 'Lampas sa limitasyon ng pag-withdraw ngayong araw',
  'err.WITHDRAW_NOT_PENDING': 'Naproseso na ang kahilingang iyon',

  'ref.needLogin': 'Mag-log in para makita ang iyong link sa pagbabahagi',
  'ref.myLink': 'Aking link sa pagbabahagi',
  'ref.copy': 'Kopyahin',
  'ref.copied': 'Nakopya na',
  'ref.code': 'Code ng imbitasyon: {v}',
  'ref.pending': 'Hindi pa nakukuhang komisyon',
  'ref.claim': 'Kunin',
  'ref.claimed': 'Nakuha ang {v}, +{n} libreng spin',
  'ref.claimedCash': 'Nakuha ang {v}',
  'ref.spins_one': '{n} libreng spin',
  'ref.spins_other': '{n} libreng spin',
  'ref.team': 'Aking team',
  'ref.level': 'Antas {n}',
  'ref.effN_one': '{n} kwalipikado',
  'ref.effN_other': '{n} kwalipikado',
  'ref.tapForList': 'Pumili ng antas para makita ang listahan',
  'ref.levelTitle': 'Mga referral sa antas {n}',
  'ref.total_one': '{n} tao',
  'ref.total_other': '{n} tao',
  'ref.noOne': 'Wala pa sa antas na ito',
  'ref.noName': 'Walang palayaw',
  'ref.effective': 'Kwalipikado',
  'ref.notEffective': 'Hindi pa',
  'ref.prev': 'Nakaraan',
  'ref.next': 'Susunod',
  'ref.chests': 'Mga kahon ng gantimpala',
  'ref.needN_one': '{n} kwalipikado',
  'ref.needN_other': '{n} kwalipikado',
  'ref.leftN_one': '{n} pa ang kulang',
  'ref.leftN_other': '{n} pa ang kulang',
  'ref.open': 'Buksan',
  'ref.claimedOne': 'Nabuksan na',
  'ref.chestGot': 'Natanggap ang {v}, +{n} libreng spin',
  'ref.chestGotCash': 'Natanggap ang {v}',
  'ref.rules': 'Paano ito gumagana',
  'ref.r1': 'Ang mga kaibigang magrerehistro gamit ang iyong link ay magiging referral mo sa antas 1; ang kanilang mga referral ay antas 2, at ang mga susunod ay antas 3.',
  'ref.r2': 'Magiging kwalipikado ang referral kapag umabot sa {d} ang kabuuang deposito at {b} ang kabuuang taya niya.',
  'ref.r3': 'May komisyon hanggang {n} antas, ayon sa mga rate sa ibaba, batay sa aktuwal na ibinayad ng iyong referral.',
  'ref.r4': 'Hindi awtomatikong idinadagdag ang komisyon — kunin ito sa pahinang ito. Kapag naabot ang itinakdang bilang ng kwalipikadong referral sa antas 1, magbubukas ang isang kahon ng gantimpala; isang beses lang mabubuksan ang bawat kahon.',
  'ref.tLevel': 'Antas',
  'ref.tRate': 'Rate',
  'ref.tSpins': 'Libreng spin',
  'ref.version': 'Bersyon ng mga tuntunin: {v}',

  'pay.title': 'Kumpletuhin ang pagbabayad',
  'pay.amount': 'Halagang babayaran',
  'pay.copy': 'Kopyahin ang PIX code',
  'pay.copied': 'Nakopya na',
  'pay.howto': 'Kopyahin ang code, buksan ang app ng iyong bangko at piliin ang PIX “paste code” para magbayad.',
  'pay.noCode': 'Walang ibinigay na makokopyang code ang provider — gamitin ang pahina ng pagbabayad sa ibaba.',
  'pay.openPage': 'Buksan ang pahina ng pagbabayad',
  'pay.expiresIn': 'Mag-e-expire sa loob ng {v}',
  'pay.waiting': 'Awtomatikong mag-a-update ang pahinang ito kapag nakabayad ka na — hindi kailangang umalis.',
  'pay.crediting': 'Natanggap ang bayad, idinadagdag sa balanse…',
  'pay.done': 'Naidagdag na',
  'pay.orderNo': 'Order',
  'pay.st.expired': 'Nag-expire na ang code ng pagbabayad na ito',
  'pay.st.cancelled': 'Kinansela ang order na ito',
  'pay.again': 'Gumawa ng bagong order',

  'action.back': 'Bumalik',
  'frame.blocked': 'Hindi maipakita rito ang pahinang ito. Gamitin ang opsyon sa ibaba.',
  'frame.pay': 'Pagbabayad',
  'frame.game': 'Laro',
  'frame.gameBlocked': 'Hindi nag-load ang laro. Subukan muli mamaya.',
  'frame.exitGame': 'Bumalik sa lobby',
  'pay.toastOk': 'Naidagdag na ang bayad, +{v} coin',
};
